/**
 * img-logos.js
 * Staggered entry animation for logo blocks using GSAP
 */

/*
 * Wrapped in an IIFE: this file is loaded from inside the section markup, so a
 * template with two img-logos sections executes it twice. At top level that
 * re-declared `class ImgLogosSection` and threw; scoped here, the second run is
 * a no-op thanks to the customElements guard below.
 */
(() => {
  class ImgLogosSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._init();
      // Re-init on section load (Shopify Editor)
      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.contains(this)) this._init();
      });
    }

    _init() {
      const blocks = this.querySelectorAll('.img-logos__block');
      if (!blocks.length) return;

      // Register ScrollTrigger if available
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
      } else {
        // Fallback: simple visibility
        blocks.forEach(b => {
          b.style.opacity = '1';
          b.style.transform = 'translateY(0)';
        });
        return;
      }

      // Animate blocks with stagger
      gsap.fromTo(blocks, 
        { 
          opacity: 0, 
          y: 40 
        }, 
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: this,
            start: 'top 85%', // Trigger when the section top is 85% into viewport
            toggleActions: 'play none none none' // Play once
          }
        }
      );
    }
  }

  if (!customElements.get('img-logos-section')) {
    customElements.define('img-logos-section', ImgLogosSection);
  }
})();
